module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('h2', [_vm._v("Lunar Calendar Conversion Test Page")]), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-container', {
    staticClass: "pa-4",
    attrs: {
      "grid-list-sm": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": "",
      "xs12": "",
      "align-left": "",
      "justify-space-between": ""
    }
  }, [_c('h3', [_vm._v("Gregorian Input")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-menu', {
    model: {
      value: (_vm.menuDateStart),
      callback: function($$v) {
        _vm.menuDateStart = $$v
      },
      expression: "menuDateStart"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Select Gregorian Date",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": ""
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Number of days to deduct",
      "value": "7 days",
      "type": "text"
    },
    model: {
      value: (_vm.days),
      callback: function($$v) {
        _vm.days = $$v
      },
      expression: "days"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.calc($event)
      }
    }
  }, [_vm._v("Calculate Lunar Date")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "offset-md1": "",
      "xs12": "",
      "align-left": "",
      "justify-space-between": ""
    }
  }, [_c('h3', [_vm._v("Lunar Result")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.resultsLoaded) ? _c('v-text-field', {
    attrs: {
      "label": "Lunar date",
      "type": "text",
      "disabled": ""
    },
    model: {
      value: (_vm.lunarStartDate),
      callback: function($$v) {
        _vm.lunarStartDate = $$v
      },
      expression: "lunarStartDate"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.resultsLoaded) ? _c('v-text-field', {
    attrs: {
      "label": ("Lunar date minus " + _vm.days),
      "value": "7 days",
      "type": "text",
      "disabled": ""
    },
    model: {
      value: (_vm.lunarFinalDate),
      callback: function($$v) {
        _vm.lunarFinalDate = $$v
      },
      expression: "lunarFinalDate"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7ddbfb8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TestCalendar.vue
// module id = 1025
// module chunks = 1